import { useContext } from 'react';
import { TeamInviteContext } from 'contexts/team_invite_context';

const useTeamInvite = () => {
    return useContext(TeamInviteContext);
};

export default useTeamInvite;
